import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

const PageToolbarContext = createContext(null);

export function usePageToolbarContext() {
  const ctx = useContext(PageToolbarContext);
  if (!ctx) {
    throw new Error('usePageToolbarContext must be used within PageToolbarProvider');
  }
  return ctx;
}

/**
 * Register page toolbar actions into the sticky content-column strip under the navbar.
 * Cleared on unmount.
 * @param {React.ReactNode} actions
 * @param {any[]} deps - recalculate when these change
 */
export function usePageToolbar(actions, deps = []) {
  const { setToolbarActions } = usePageToolbarContext();

  useEffect(() => {
    setToolbarActions(actions);
    return () => setToolbarActions(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}

export function PageToolbarProvider({ children }) {
  const [toolbarActions, setToolbarActionsState] = useState(null);

  const setToolbarActions = useCallback((node) => {
    setToolbarActionsState(node);
  }, []);

  const value = useMemo(
    () => ({ toolbarActions, setToolbarActions }),
    [toolbarActions, setToolbarActions]
  );

  return (
    <PageToolbarContext.Provider value={value}>
      {children}
    </PageToolbarContext.Provider>
  );
}
